export default {
  fi: {
    VehicleEditScene: {
      confirmDeleteVehicle:
        'Haluatko varmasti poistaa ajoneuvon? Kaikki siihen liitetyt huollot ja muistutkset poistetaan samalla. Poistoa ei voi peruuttaa hyväksymisen jälkeen.',
      editVehicle: 'Muokkaa ajoneuvoa',
    },
  },
};
